"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParseRuntimeException = void 0;
var ParseRuntimeException = /** @class */ (function (_super) {
    __extends(ParseRuntimeException, _super);
    function ParseRuntimeException(message, bookmark, digest) {
        var _this = _super.call(this, message + ', ' + bookmark + ', digest:' + digest) || this;
        _this.bookmark = bookmark;
        _this.digest = digest;
        _this.bookmark = bookmark;
        _this.digest = digest;
        return _this;
    }
    ParseRuntimeException.prototype.getBookmark = function () {
        return this.bookmark.clone();
    };
    return ParseRuntimeException;
}(Error));
exports.ParseRuntimeException = ParseRuntimeException;
//# sourceMappingURL=ParseRuntimeException.js.map